import React, { useState, useEffect } from "react";
import AddIcon from "@material-ui/icons/Add";
import MUIDataTable from "mui-datatables";
import axios from "axios";
import IconButton from "@material-ui/core/IconButton";
import Popup from "../../../../components/Controls/Popup";
import Notification from "../../../../components/SnackBar/Notification";
import { makeStyles, Tooltip } from "@material-ui/core";
import Controls from "../../../../components/Controls/Controls";
import Details from "@material-ui/icons/Details"
import MCMachineDetails from "../maintenanceCoordinate/MCMachineDetails";
import { ThemeProvider } from '@mui/material/styles';
import CustomTheme from "../../../../components/CustomTheme/CustomTheme";
import { CustomCircularProgress } from "../../../../components/Progress/CustomCircularProgress";
import { Box } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  pageContent: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    padding: theme.spacing(3),
  },
  iconButtonColor: {
    color: "#fff",
    "&:hover": {
      color: "#0000ff",
    },
  },
}));

export default function MHMachineOutApproval() {
  const classes = useStyles();
  const [machineTransferList, setMachineTransferList] = useState([]);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [machineTransferRecord, setMachineTransferRecord] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [openDetailsPopup, setOpenDetailsPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  var userType = localStorage.getItem('user_type');

  const AxiosHeader = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem("access_token")}`
    },
  }

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  async function fetchMachineTransfer() {
    try {
    setIsLoading(true);
      await axios
        .get("/api/mh/machine/transfer/out/list/", AxiosHeader)
        .then((res) => {
          setMachineTransferList(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  }

  const updateMachineTransfer = async (values, ) => {
    try {
      await axios
        .put(`/api/mh/machine/transfer/out/update/`, values, AxiosHeader)
        .then((resp) => {
          setMachineTransferRecord(resp.data);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const openInDetailsPopup = (item) => {
    setRecordForEdit(item);
    setOpenDetailsPopup(true);
  };

  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    fetchMachineTransfer();
  }, [machineTransferRecord]);

  const columns = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "name",
      label: "Chalan No (System)",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "manual_chalan_no",
      label: "Chalan No (Book)",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "to_unit_name",
      label: "Transfer To",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "type_name",
      label: "Transfer Type",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "chalan_date_",
      label: "Chalan Date",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "receive_date_",
      label: "Receive Date",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "return_date_",
      label: "Return Date",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "carrier_name",
      label: "Carrier Name",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "purpose",
      label: "Purpose",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "remark",
      label: "Remark",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Actions",
      options: {
        filter: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          let item;
          tableMeta.tableData.forEach(function (machineTransfer) {
            if (machineTransfer.id == tableMeta.rowData[0])
              return (item = machineTransfer);
          });
          return (
            <>
              {
              (userType == 'Admin' || userType == 'Maintenance Head') && item['status'] === 'IE_OUT' ? 
              <IconButton
                color="primary"
                onClick={() => {
                  updateMachineTransfer(item);
                }}
              >
                <Controls.Button
                  type="submit"
                  text="Approve"
                  style={{backgroundColor: "purple"}}
                />
              </IconButton> : ''
              }
              <IconButton
                color="primary"
                onClick={() => {
                  openInDetailsPopup(item);
                }}
              >
                <Details fontSize="medium" style={{'color': 'purple'}} />
              </IconButton>
            </>
          );
        },
      },
    },
  ];

  const options = {
    filterType: "dropdown",
    selectableRows: "none",
    responsive: "standard",
    customToolbar: () => {
      return (
        <Tooltip title={"Add New"}>
          <IconButton className={classes.iconButtonColor}
            onClick={() => {
              setOpenPopup(true);
              setRecordForEdit(null);
            }}
          >
            <AddIcon />
          </IconButton>
        </Tooltip>
      );
    },
    print: false,
    download: false,
  };

  return (
    <React.Fragment>
      <Box position="relative">
    <ThemeProvider theme={CustomTheme}>
    <div>
      <MUIDataTable
        title={"MH Machine Out Approval"}
        data={machineTransferList}
        columns={columns}
        options={options}
        className={classes.pageContent}
      />
        {isLoading && (
          <Box position="absolute" top="60%" left="40%" transform="translate(-50%, -50%)">
            <CustomCircularProgress size={50} thickness={6} color="secondary" message="Data is loading. Please do not close the tab..." />
          </Box>
        )}

      <Popup
        title="Machine Transfer Details"
        openPopup={openDetailsPopup}
        setOpenPopup={setOpenDetailsPopup}
      >
        <MCMachineDetails recordForEdit={recordForEdit} machineTransferList={machineTransferList} />
      </Popup>
      <Notification notify={notify} setNotify={setNotify} />
    </div>
    </ThemeProvider>
    </Box>
  </React.Fragment>
  );
}
